export default "__VITE_ASSET__BVnAnyYb__"